import styled from 'styled-components/macro';
import { space } from '../../../theme/tokens';

export const ChatContainer = styled.section`
  grid-area: chat;
  min-height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: auto min-content;
  grid-template-areas: 'messages' 'messageForm';
`;

export const ChatMessagesList = styled.ul`
  grid-area: messages;
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
  background: ${({ theme }) => theme.chatBackground};
  list-style: none;
  padding: ${space[2]};
  margin: 0;
  overflow-x: hidden;
  overflow-y: scroll;
`;
